import { Component, OnInit } from '@angular/core';
import { TuitionNavbarComponent } from '@tuition/shared/components/tuition-navbar';
import { constants } from '@edassist/common';
import { SliderDirection } from '@edassist-ui/slider';

@Component({
	selector: 'tu-mobile-menu',
	templateUrl: './tuition-mobile-menu.component.html',
	styleUrls: ['./tuition-mobile-menu.component.scss']
})
export class TuitionMobileMenuComponent
	extends TuitionNavbarComponent
	implements OnInit
{
	SliderDirection = SliderDirection;
	isShowMobileNav = false;

	toggleMobileActive(): void {
		this.sliderService.openSlider(constants.sliderIds.MOBILE_NAV);
		this.isShowMobileNav = true;
	}

	closeSlider(): void {
		this.sliderService.closeSlider(constants.sliderIds.MOBILE_NAV);
		this.isShowMobileNav = false;
	}

	isActivePage(url: string): boolean {
		return super.isActivePage(url);
	}

	ngOnInit(): void {
		super.ngOnInit();
	}
}
